module.exports = __webpack_public_path__ + "static/img/dataLeakInstallForMac_pic4.bc66e82.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/dataLeakInstallForMac/dataLeakInstallForMac_pic4.png
// module id = 483
// module chunks = 1